import { Component } from '@angular/core';

@Component({
  selector: 'app-youth',
  templateUrl: './youth.component.html',
  styleUrl: './youth.component.scss'
})
export class YouthComponent {

}
